import { mapState } from 'vuex';
import pickBy from 'lodash/pickBy';
import { vuetifyColors } from '@/utils/themes';
const defaultItemsPerPage = 10;
export default {
  name: 'NiotaClassicDevicesUploadList',
  props: {
    tblHeaders: {
      type: Array,
      default: new Array()
    },
    contents: {
      type: Array,
      default: new Array()
    }
  },
  data: function () {
    return {
      tableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
      },
      searchItem: null,
      expanded: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    filteredContent() {
      let result = null;
      this.contents.forEach(content => {
        result = pickBy(content, (value, key) => {
          switch (key) {
            case 'applicationId':
            case 'originatorId':
            case 'originator':
            case 'deviceTypeId':
            case 'connectivityPlanId':
            case 'deviceProfileId':
            case 'properties':
            case 'otaa':
            case 'error':
            case 'valid':
            case 'add':
            case 'cType':
            case 'msg':
              return false;
            default:
              return true;
          }
        });
      });
      return result;
    }
  },
  methods: {
    filterItems(item, queryText) {
      return item.title.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    deleteRow(index) {
      this.$emit('deleteRow', index);
    },
    deleteColumn(index) {
      this.$emit('deleteVariable', index);
    },
    getColor(type) {
      return vuetifyColors[type];
    }
  }
};